// articles list
export const ARTICLES_LIST_REQUEST = "ARTICLES_LIST_REQUEST"
export const ARTICLES_LIST_SUCCESS = "ARTICLES_LIST_SUCCESS"
export const ARTICLES_LIST_FAIL = "ARTICLES_LIST_FAIL"

// article details
export const ARTICLE_DETAILS_REQUEST = "ARTICLE_DETAILS_REQUEST"
export const ARTICLE_DETAILS_SUCCESS = "ARTICLE_DETAILS_SUCCESS"
export const ARTICLE_DETAILS_FAIL = "ARTICLE_DETAILS_FAIL"
export const ARTICLE_DETAILS_RESET = "ARTICLE_DETAILS_RESET"

// article create
export const ARTICLES_CREATE_REQUEST = "ARTICLES_CREATE_REQUEST"
export const ARTICLES_CREATE_SUCCESS = "ARTICLES_CREATE_SUCCESS"
export const ARTICLES_CREATE_FAIL = "ARTICLES_CREATE_FAIL"

// article delete
export const ARTICLE_DELETE_REQUEST = 'ARTICLE_DELETE_REQUEST'
export const ARTICLE_DELETE_SUCCESS = 'ARTICLE_DELETE_SUCCESS'
export const ARTICLE_DELETE_FAIL = 'ARTICLE_DELETE_FAIL'

// article edit
export const ARTICLE_EDIT_REQUEST = 'ARTICLE_EDIT_REQUEST'
export const ARTICLE_EDIT_SUCCESS = 'ARTICLE_EDIT_SUCCESS'
export const ARTICLE_EDIT_FAIL = 'ARTICLE_EDIT_FAIL'

// article image edit
export const ARTICLE_IMAGE_EDIT_REQUEST = 'ARTICLE_IMAGE_EDIT_REQUEST'
export const ARTICLE_IMAGE_EDIT_SUCCESS = 'ARTICLE_IMAGE_EDIT_SUCCESS'
export const ARTICLE_IMAGE_EDIT_FAIL = 'ARTICLE_IMAGE_EDIT_FAIL'

// user login/logout
export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST"
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS"
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL"
export const USER_LOGOUT = "USER_LOGOUT"

// user registration/signup
export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST"
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS"
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL"

// user account details
export const USER_ACCOUNT_REQUEST = "USER_ACCOUNT_REQUEST"
export const USER_ACCOUNT_SUCCESS = "USER_ACCOUNT_SUCCESS"
export const USER_ACCOUNT_FAIL = "USER_ACCOUNT_FAIL"
export const USER_ACCOUNT_RESET = "USER_ACCOUNT_RESET"

// update user account detials
export const UPDATE_USER_ACCOUNT_REQUEST = "UPDATE_USER_ACCOUNT_REQUEST"
export const UPDATE_USER_ACCOUNT_SUCCESS = "UPDATE_USER_ACCOUNT_SUCCESS"
export const UPDATE_USER_ACCOUNT_FAIL = "UPDATE_USER_ACCOUNT_FAIL"
export const UPDATE_USER_ACCOUNT_RESET = "UPDATE_USER_ACCOUNT_RESET"

// delete user account (normal user)
export const USER_ACCOUNT_DELETE_REQUEST = "USER_ACCOUNT_DELETE_REQUEST"
export const USER_ACCOUNT_DELETE_SUCCESS = "USER_ACCOUNT_DELETE_SUCCESS"
export const USER_ACCOUNT_DELETE_FAIL = "USER_ACCOUNT_DELETE_FAIL"

// all users
export const ALL_USERS_DETAIL_REQUEST = "ALL_USERS_DETAIL_REQUEST"
export const ALL_USERS_DETAIL_SUCCESS = "ALL_USERS_DETAIL_SUCCESS"
export const ALL_USERS_DETAIL_FAIL = "ALL_USERS_DETAIL_FAIL"

// change user admin status
export const CHANGE_ADMIN_STATUS_REQUEST = "CHANGE_ADMIN_STATUS_REQUEST"
export const CHANGE_ADMIN_STATUS_SUCCESS = "CHANGE_ADMIN_STATUS_SUCCESS"
export const CHANGE_ADMIN_STATUS_FAIL = "CHANGE_ADMIN_STATUS_FAIL"

// delete user (admin side)
export const DELETE_USER_BY_ADMIN_REQUEST = "DELETE_USER_BY_ADMIN_REQUEST"
export const DELETE_USER_BY_ADMIN_SUCCESS = "DELETE_USER_BY_ADMIN_SUCCESS"
export const DELETE_USER_BY_ADMIN_FAIL = "DELETE_USER_BY_ADMIN_FAIL"